const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, Record<string, Record<string, string>>> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang, namespace] = match;
    const module = modules[path] as Record<string, unknown>;

    if (!messages[lang]) {
      messages[lang] = {};
    }

    if (!messages[lang][namespace]) {
      messages[lang][namespace] = {};
    }

    // Try default export first, then fall back to first object named export
    let translations: Record<string, string> = {};
    if (module.default && typeof module.default === 'object' && module.default !== null) {
      translations = module.default as Record<string, string>;
    } else {
      const namedExport = Object.values(module).find(
        (v) => typeof v === 'object' && v !== null && !Array.isArray(v)
      ) as Record<string, string> | undefined;
      if (namedExport) translations = namedExport;
    }

    messages[lang][namespace] = {
      ...messages[lang][namespace],
      ...translations,
    };
  }
});

export default messages;